export default class Logger {
  constructor(optons) {
    this.debug = optons.debug || false;
  }

  log(...args) {
    if (!this.debug) return;
    const now = new Date().toLocaleTimeString();
    console.log(`WebUploader [${now}]`, ...args);
  }

  error(...args) {
    if (!this.debug) return; 
    const now = new Date().toLocaleTimeString();
    console.error(`WebUploader [${now}]`, ...args);
  }

  warn(...args) {
    if (!this.debug) return; 
    const now = new Date().toLocaleTimeString();
    console.warn(`WebUploader [${now}]`, ...args);
  }
}
